// @ts-strict-ignore
import type { AttributeConfigurationFormState } from './types';
import type { PublishedAttribute } from '~/dashboard/views/workflows/store/engine/types';

/**
 * Maps form data to published attribute data, transforming empty strings to null
 * to match the behavior of the Daffy API endpoint (getPublishedAttributesAddPayload).
 * This ensures consistency between Typhon (local) and Daffy (remote) save paths.
 *
 * @param formData - The form state from react-hook-form
 * @returns Partial published attribute with only updatable fields transformed
 */
export function mapFormDataToPublishedAttributeProp(
  formData: AttributeConfigurationFormState,
): Partial<PublishedAttribute> {
  return {
    // Updatable fields - transform empty strings to null
    attributeName: formData.attributeName,
    defaultValue: formData.defaultValue,
    defaultValueNote: formData.defaultValueNote || null,
    groupingToken: formData.groupingToken || null,
    jqFilter: formData.hasJqFilter ? (formData.jqFilter || null) : null,
    validValueMin: formData.validValueMin || null,
    validValueMax: formData.validValueMax || null,
    validValues: formData.validValues || null,
    hasExpiration: formData.hasExpiration,
    hasJqFilter: formData.hasJqFilter,
    valueExpiresInDays: formData.valueExpiresInDays,
    agentCanCreateValue: formData.agentCanCreateValue,
  };
}

